// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3SyIW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1fclF"};